import { createGTStore } from '@blast-engine/gt-store'

export const gtstore = createGTStore().start()
export const gts = gtstore